import { VariantProps, cva } from 'class-variance-authority'
import React, { HTMLAttributes } from 'react'

import { A } from '@frame/ui-primitives/a'
import { Button } from '@frame/ui-primitives/button'
import { P } from '@frame/ui-primitives/p'
import { PoweredByTruework } from '@frame/ui-primitives/powered-by-truework'

import { cn } from '@frame/lib/utils/cn'
import { DataAttribute } from '@frame/types'

const variants = cva('p-5 rounded-t-none rounded-b-md space-y-4 bg-white', {
  variants: {
    showDisclaimer: {
      true: 'space-y-0 p-0',
    },
    hasBackgroundColor: {
      false: 'bg-transparent',
    },
    noBottomPadding: {
      true: 'pb-0',
    },
  },
  defaultVariants: {
    showDisclaimer: false,
    hasBackgroundColor: true,
    noBottomPadding: false,
  },
})

type Props = {
  showDisclaimer?: VariantProps<typeof variants>['showDisclaimer']
  showPoweredByTruework?: boolean
  buttons: {
    primary: ReturnType<typeof Button>
    secondary?: ReturnType<typeof Button>
  }
  hasBackgroundColor?: VariantProps<typeof variants>['hasBackgroundColor']
  noBottomPadding?: VariantProps<typeof variants>['noBottomPadding']
  className?: HTMLAttributes<HTMLDivElement>['className']
}

export function Footer({
  showDisclaimer,
  showPoweredByTruework = false,
  buttons,
  hasBackgroundColor,
  noBottomPadding,
  className,
}: Props) {
  return (
    <footer
      data-cy={DataAttribute.FOOTER}
      className={cn(className, variants({ showDisclaimer, hasBackgroundColor, noBottomPadding }))}
    >
      {showDisclaimer ? (
        <>
          <div className="flex flex-col items-center px-5 py-4">
            <TermsAndPrivacy />
            {buttons.primary}
          </div>
        </>
      ) : (
        <>
          {buttons.primary}
          {buttons.secondary && buttons.secondary}
        </>
      )}
      {showPoweredByTruework && <PoweredByTruework />}
    </footer>
  )
}

function TermsAndPrivacy() {
  return (
    <>
      <P variant="xxsmall" className="mb-2">
        By continuing, you agree to Truework's{' '}
        <A
          data-cy={DataAttribute.CONSENT_TERMS}
          href="https://www.truework.com/terms/consumers"
          target="_blank"
          rel="noreferrer"
        >
          Terms
        </A>{' '}
        and{' '}
        <A
          data-cy={DataAttribute.CONSENT_PRIVACY_POLICY}
          href="https://www.truework.com/privacy"
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </A>
        .
      </P>
    </>
  )
}
